module.exports = __webpack_public_path__ + "img/main_background.b53d5604.png";